<template>
  <div>
    <div :key="key" class="mindmap-container">
      <Toolbar />
      <Edit :org-data="caseTreeData" />
    </div>
  </div>
</template>

<script>
import Toolbar from './components/Toolbar';
import Edit from './components/Edit';
import './assets/icon-font/iconfont.css';
import { caseList, moduleList } from '@/api/project/case';
export default {
  components: {
    Toolbar,
    Edit
  },
  data() {
    return {
      key: 0,
      moduleCases: [],
      moduleData: [],
      caseDataList: [],
      caseTreeData: {
        name: '全部case',
        children: [
          {
            name: '模块一'
          },
          {
            name: 'case一'
          }
        ]
      }
    };
  },
  mounted() {
    this.getModuleList();
  },
  methods: {
    buildCaseToModule(treeData, cases) {
      if (!treeData) return;
      if (!treeData.children) treeData.children = [];
      treeData.children.forEach(c => {
        this.buildCaseToModule(c, cases);
      });
      const childrenCases = cases.filter(c => c.module_id === treeData.id);
      treeData.children.push(...childrenCases);
    },
    // 获取用例列表
    async getCaseList() {
      const { code, message, data } = await caseList({ project_id: 5, module_id: -1, page_size: 10000, page_number: 1 });
      if (code === 2000) {
        this.caseDataList = data.items;
        this.buildCaseToModule(this.caseTreeData, this.caseDataList);
        this.key++;
      } else {
        console.error(message);
      }
    },
    getModuleList() {
      moduleList({ project_id: 5 })
        .then(res => {
          this.moduleCases = res.data.module_cases;
          const items = JSON.parse(JSON.stringify(res.data.items));
          const children = [
            {
              id: 0,
              key: 0,
              title: '未分配',
              name: '未分配',
              total: this.moduleCases[null] || 0,
              scopedSlots: { title: 'title' },
              children: []
            },
            ...this.listToTree(items)
          ];
          const trashedChildren = [
            {
              id: -3,
              key: -3,
              title: '未分配',
              name: '未分配',
              total: this.moduleCases['null-trashed'] || 0,
              scopedSlots: { title: 'title' },
              children: []
            },
            ...this.listToTree(res.data.items, 0, true)
          ];
          const total = children.reduce((sum, c) => sum + (c.total || 0), 0);
          const trashedTotal = trashedChildren.reduce((sum, c) => sum + (c.total || 0), 0);
          this.moduleData = [
            {
              id: -1,
              key: -1,
              title: '正常用例',
              name: '正常用例',
              total: total,
              scopedSlots: { title: 'title' },
              children: children
            },
            {
              id: -2,
              key: -2,
              title: '已废弃',
              name: '已废弃',
              total: trashedTotal,
              scopedSlots: { title: 'title' },
              children: trashedChildren
            }
          ];

          this.caseTreeData = this.moduleData[0];
          this.getCaseList();
          // this.key++;
        })
        .catch(() => {
        });
    },
    listToTree(list, parentId = 0, trashed = false) {
      const menuObj = {};
      const tempArr = [];
      list.forEach(item => {
        let total = this.moduleCases[item.id] || 0;
        if (trashed) {
          total = this.moduleCases[item.id + '-trashed'] || 0;
        }
        const temp = { ...item, total: total, scopedSlots: { title: 'title' }, children: [] };
        tempArr.push(temp);
        menuObj[item.id] = temp;
      });
      let treeData = tempArr.filter(item => {
        if (item.parent_id !== parentId) {
          let father = menuObj[item.parent_id];
          // 父目录被删除，子目录不展示
          if (!father) {
            return false;
          }
          father.children.push(item);
          let total = this.moduleCases[item.id] || 0;
          if (trashed) {
            total = this.moduleCases[item.id + '-trashed'] || 0;
            item.key = 0 - item.key;
          }

          father.total += total;
          if (trashed && father.key > 0) {
            father.key = 0 - father.key;
          }
          // 深度搜索
          while (father.parent_id !== parentId) {
            father = menuObj[father.parent_id];
            if (!father) {
              break;
            }
            total = this.moduleCases[item.id] || 0;
            if (trashed) {
              total = this.moduleCases[item.id + '-trashed'] || 0;
            }
            father.total += total;
            if (trashed && father.key > 0) {
              father.key = 0 - father.key;
            }
          }
          return false;
        }
        return true;
      });
      if (trashed) {
        treeData = treeData.filter(item => {
          this.clearTreeNodeChildren(item);
          return item.total > 0;
        });
      }
      return treeData;
    },
    clearTreeNodeChildren(node) {
      const children = node.children;
      if (children) {
        node.children = node.children.filter(c => c.total > 0);
        for (let i = 0; i < node.children.length; i++) {
          this.clearTreeNodeChildren(node.children[i]);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
#mindMapContainer * {
  margin: 0;
  padding: 0;
}

/* 添加样式确保思维导图正常显示 */
.mindmap-container {
  position: relative;
  width: 100%;
  height: calc(~'100vh - 140px');
}
</style>
